import { configureStore } from '@reduxjs/toolkit'
import { RootReducer, RootEpic } from './Root'
import { createEpicMiddleware } from 'redux-observable'
import { rtkQueryErrorNotifier } from './ApiErrorMiddleware'
import { api } from '../Services/Api'

// side effects
const epicMiddleware = createEpicMiddleware()

const store = configureStore({
  reducer: RootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(epicMiddleware, api.middleware, rtkQueryErrorNotifier),
  devTools: process.env.NODE_ENV !== 'production',
})

epicMiddleware.run(RootEpic)

export default store
